export const ADD_UPDATE = 'ADD_UPDATE';
export const GET_UPDATES = 'GET_UPDATES'
export const SHOW_LOADER = 'SHOW_LOADER'
export const SHOW_MESSAGE = 'SHOW_MESSAGE'
export const CALL_NOTIFICATIONS = 'CALL_NOTIFICATIONS'